import React, { useEffect, useState } from "react";
import Layout from "../common/Layout";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import ContactUsForm from "../components/contact-us-form/ContactUsForm";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
          "https://portal.ebs365.info/api/sites/3/settings"
        );
        const data = await response.json();
        setSiteSettings(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);

  const info = (siteSettings && siteSettings.data) || {};
  const offices = info.offices || [];
  const secondOfficeEmail =
    offices[0] && offices[0].email ? offices[0].email : "";

  return (
    <>
      <Helmet>
        <title>Contact Us || RSS Security and Investigations Pty Ltd</title>
        <meta
          name="description"
          content="Securepress - Security Company React  Template"
        />
        <meta
          name="keywords"
          content="safety, bodyguard, cctv, emergency, Event Security, fire, investigation, investigator, officer, protection, security, Security Camera, Care, Parking  Security"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle="Contact Us"
          rootPath="/"
          parentPath="Home"
          currentPath="Contact Us"
        />
        {/* Contact Page Section Start */}
        <div className="contact-page-sec pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="contact-field">
                  <h2>Write Your Message</h2>
                  <ContactUsForm />
                </div>
              </div>
              <div className="col-md-4">
                <div>
                  <h2>Address</h2>
                  <div className="media-body">
                    <span className="inner-text">{info.address || ""}</span>
                  </div>
                </div>
                <div className="mt-3">
                  <h2>Email</h2>
                  <div className="media-body">
                    <span className="inner-text">
                      {info.email ? (
                        <a
                          href={`mailto:${info.email}`}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                        >
                          {info.email}
                        </a>
                      ) : (
                        ""
                      )}
                    </span>
                    <br></br>

                    <span className="inner-text">
                      {secondOfficeEmail ? (
                        <a
                          href={`mailto:${secondOfficeEmail}`}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                        >
                          {secondOfficeEmail}
                        </a>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
                <div className="mt-3">
                  <h2>Phone</h2>
                  <div className="media-body">
                    <span className="inner-text">
                      {info.phone ? (
                        <a
                          href={`tel:${info.phone}`}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                        >
                          {info.phone}
                        </a>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Contact Page Section End */}
      </Layout>
    </>
  );
};

export default ContactUs;